export default __webpack_public_path__ + "static/loading-1478a081359e68895d5a78caaadb3ec9.png";